import React, { useState, useCallback, useEffect } from 'react';
import Header from '../../components/ui/Header';
import WelcomeHeader from './components/WelcomeHeader';
import ChatContainer from './components/ChatContainer';
import ChatInput from './components/ChatInput';
import ChatSuggestions from 'components/ChatSuggestions';


const FinancialChatInterface = () => {
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const BACKEND_URL = "https://financial.deepmine.ir/s2";

  // 📌 Fetch message history on mount
  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const user_id = sessionStorage.getItem("user_id");
        if (!user_id || user_id === "null") {
          alert("please login first");
          window.location.href = "/login";
          return;
        }
        const response = await fetch(`${BACKEND_URL}/messages`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "X-User-ID": user_id
          },
          credentials: "include"
        });

        const data = await response.json();

        if (data.redirect) {
          alert("please login first")
          window.location.href = data.redirect;
          return;
        }

        if (response.ok) {
          setMessages(
            data.map(msg => ({
              ...msg,
              timestamp: msg.timestamp ? new Date(msg.timestamp) : new Date()
            }))
          );
        }
      } catch (error) {
        console.error("❌ Error fetching messages:", error);
      }
    };

    fetchMessages();
  }, []);

  // Send message
  const handleSendMessage = useCallback(async (messageContent) => {
    const userMessage = {
      content: messageContent,
      isUser: true,
      timestamp: new Date()
    };

    setMessages(prev => [...prev, userMessage]);
    setIsLoading(true);

    try {
      const user_id = sessionStorage.getItem('user_id');
      if (!user_id || user_id === "null") {
          alert("please login first");
          window.location.href = "/login";
          return;
      }
      const response = await fetch(`${BACKEND_URL}/chat`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-User-ID': user_id
        },
        credentials: 'include',
        body: JSON.stringify({ message: messageContent })
      });

      const data = await response.json();

      if (data.redirect) {
        alert("please login first")
        window.location.href = data.redirect;
        return;
      }

      const assistantMessage = {
        content: data.response || "❌ No response from server.",
        isUser: false,
        timestamp: new Date()
      };

      setMessages(prev => [...prev, assistantMessage]);
    } catch (error) {
      setMessages(prev => [...prev, {
        content: "❌ Server error. Please try again later.",
        isUser: false,
        timestamp: new Date()
      }]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  // Reset chat
  const handleResetChat = () => {
    setMessages([]);
    console.log("چت ریست شد");
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="pt-16 flex flex-col h-screen">
        <WelcomeHeader />
        <ChatContainer 
          messages={messages} 
          isLoading={isLoading}
        />

        {messages.length === 0 && (
          <ChatSuggestions 
            onSuggestionClick={handleSendMessage} 
            isLoading={isLoading}
          />
        )}

        <ChatInput 
          onSendMessage={handleSendMessage}
          isLoading={isLoading}
          onResetChat={handleResetChat}
        />
      </div>
    </div>
  );
};

export default FinancialChatInterface;
